<nb-card>
    <nb-card-header>
        Hay VINS guardados que no se encuentran en el archivo
    </nb-card-header>
    <nb-card-body>
        <!-- <angular-slickgrid gridId="gridVinsDelete"
        [columnDefinitions]="columnDefinitionsVinsDelete"
        [gridOptions]="gridOptionsVinsDelete" 
        [dataset]="dataVinsDelete" 
        gridHeight="390"
        (onAngularGridCreated)="angularGridReadyVinsDelete($event)"
        (sgOnSelectedRowsChanged)="onSelectedRowsChanged($event.detail.eventData, $event.detail.args)">
      </angular-slickgrid> -->

            <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="dataVinsDelete"
            [columnDefs]="columnDefinitionsVinsDelete"
            (gridReady)="onGridReady($event)"
            rowSelection="multiple"
            (selectionChanged)="onSelectionChanged($event)"
            [enableCellTextSelection]="true" />


      <span>
        <p><strong>Seleccionados: </strong>{{cntSeleccionadas}} <strong>Total: </strong>{{totalReg}}</p>
      </span>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton size="small" status="primary" class="buttontz" style="width: 21%;" (click)="eliminarSeleccion()">Eliminar</button>
        <button nbButton size="small" status="primary" class="buttontz" style="width: 21%; float: right;" (click)="closeDialog(1)">Cerrar</button>
    </nb-card-footer>
</nb-card>